export default {
  banner: 'spotlights-banner',
};
